const KM_TO_MILES = 0.621371;

// ponytail: unit words ("miles"/"km") are not translated; move them into i18n keys
// once the result page ships in a non-English locale.
export function nextRaceCopy({ event, race_type, distance_km, weeks_out, reason_code, first_of_type }) {
  let key = "next_race_trifecta";
  if (reason_code === "first_race") key = "next_race_debut";
  else if (reason_code !== "trifecta") key = first_of_type ? "next_race_first" : "next_race_another";
  if (distance_km == null) key += "_nodist";

  const distance =
    distance_km == null
      ? ""
      : event.ts_org_code === "US"
      ? `${Math.round(distance_km * KM_TO_MILES)} miles`
      : `${Math.round(distance_km)} km`;
  const type = race_type.charAt(0) + race_type.slice(1).toLowerCase();

  return { key, params: { race_type: type, city: event.city || event.name, weeks: weeks_out, distance } };
}

const LADDER = ["STADION", "SPRINT", "SUPER", "BEAST", "ULTRA"];
const REPS = { STADION: 1, SPRINT: 2, SUPER: 2, BEAST: 1, ULTRA: 1 };
const MONTHS_PER_RACE = 3;

// ponytail: fixed reps per rung and 3 months per race, not personalised. Upgrade: return the path from next_race.
export function roadToGlory(nextType) {
  const steps = [];
  LADDER.slice(Math.max(LADDER.indexOf(nextType), 0)).forEach((type) => {
    for (let i = 0; i < REPS[type]; i++) steps.push(type);
  });
  return { steps, months: steps.length * MONTHS_PER_RACE };
}

export const latestResult = (results) =>
  [...results].sort((a, b) => (a.event_date < b.event_date ? 1 : -1))[0];

// done: finished races oldest first. next: the recommended race. then the rest of the ladder to Ultra.
export function raceTimeline(results, next) {
  const done = [...results]
    .sort((a, b) => (a.event_date > b.event_date ? 1 : -1))
    .map((r) => ({ state: "done", type: (r.event_category_name || "").toUpperCase(), result: r }));
  if (!next) return { steps: done, months: 0 };
  const { steps, months } = roadToGlory(next.race_type);
  const future = steps.map((type, i) => ({ state: i === 0 ? "next" : "future", type }));
  future[future.length - 1].state = future.length === 1 ? "next" : "goal";
  return { steps: [...done, ...future], months };
}

export function countdown(endsAt, now = Date.now()) {
  const ms = new Date(endsAt).getTime() - now;
  if (!endsAt || !(ms > 0)) return null;
  const s = Math.floor(ms / 1000);
  return { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60 };
}

export const OFFER_HOURS = 48;

// Offer runs OFFER_HOURS from the first time the racer saw it for this event, never past race start.
export function offerEndsAt(firstSeen, raceStart, hours = OFFER_HOURS) {
  const ends = new Date(firstSeen).getTime() + hours * 3600 * 1000;
  return new Date(Math.min(ends, new Date(raceStart).getTime())).toISOString();
}

// Attribution survives new tabs, re-login and the race-site round trip; sessionStorage did not.
// ponytail: last-touch within REC_HOURS on one device; cross-device needs server-side attribution.
export const REC_KEY = "sp_rec";
export const REC_HOURS = 24;

export function saveRec(store, rec, now = Date.now()) {
  store.setItem(REC_KEY, JSON.stringify({ ...rec, at: now }));
}

export function loadRec(store, now = Date.now(), hours = REC_HOURS) {
  try {
    const { at, ...rec } = JSON.parse(store.getItem(REC_KEY)) || {};
    return now - at < hours * 3600 * 1000 ? rec : {};
  } catch {
    return {};
  }
}

export const raceLocation = ({ city, state, country, name }) =>
  [city, state].filter(Boolean).join(", ") || country || name;

export const beatPercent = ({ rank_overall, count_overall }) =>
  rank_overall && count_overall ? Math.floor((1 - rank_overall / count_overall) * 100) : null;
